import { IFloorDetails, IPortfolioRegion } from '@api'
import { get, every } from 'lodash'
import some from 'lodash/fp/some'
import { LocationTreeNodeT } from './forEachNode'
import { LocationNodeType } from './renderTreeContents'

const mapLocationTreeContents = (
  regions: IPortfolioRegion[],
  paramsFloorId: string,
  allExpanded = false
) => {
  const hasFloorId = some<IFloorDetails>({ id: paramsFloorId })

  return regions.map<LocationTreeNodeT>((region, regionIndex) => ({
    id: `${region.id}-${regionIndex}`,
    hasCaret: false,
    label: region.name,
    isExpanded: true,
    isSelected: false,
    className: 'location-tree',
    nodeData: {
      nodeType: LocationNodeType.Location,
    },
    childNodes: region.cities.map((city, cityIndex) => ({
      id: `${city.id}-${cityIndex}`,
      label: city.name,
      isExpanded: allExpanded || some((building) => hasFloorId(building.floors), city.buildings),
      isSelected: false,
      nodeData: {
        nodeType: LocationNodeType.City,
        city: {
          state: get(city, 'buildings[0].state'),
          name: city.name,
        },
      },
      childNodes: city.buildings?.map((building) => ({
        id: building.id,
        label: building.name,
        isSelected: false,
        isExpanded: allExpanded || hasFloorId(building.floors),
        nodeData: {
          nodeType: LocationNodeType.Building,
          building: {
            name: building.name,
            address: building.address,
            city: building.city,
            state: building.state,
            isBuildingHidden: every(building?.floors, { hidden: true }),
          },
        },
        childNodes: building?.floors?.map((floor) => ({
          id: floor.id,
          isSelected: paramsFloorId === floor.id,
          isExpanded: false,
          hasCaret: false,
          label: floor.name,
          nodeData: {
            floor,
            nodeType: LocationNodeType.Floor,
          },
        })),
      })),
    })),
  }))
}

export default mapLocationTreeContents
